export const IS_PRODUCTION = true;
export const ALLOW_DURATION_EVENT_UPDATE = false;
const API_URL_GROUP = {
	LOCAL_DEV: "http://localhost:35069",
	DEV: "http://10.42.5.27:262",
	UTP_APP: "http://10.42.5.27:266",
	TEST: "http://10.42.5.27:22366",
	PRE_PROD: "http://10.42.5.27:22369",
	PROD: "https://apireservarecursos.utp.edu.pe",
};
export const API_URL = IS_PRODUCTION ? API_URL_GROUP.PROD : API_URL_GROUP.PROD;